import React, { Component } from 'react';
import { layoutGenerator } from 'react-break'
import {NavLink} from 'react-router-dom'
import Session from '../services/session';
import {Row, Col, Container, PureGridProvider} from '../3rdparty/react-pure-grid';
//import model from '../model.json'
import demoData from '../demoData';
import navigation from '../navigation';
import i from '../imports'
import cfg from '../config';
import validate from 'validator'

import emvIcon from '../assets/images/emv.svg';


const titleStyle = {
    color: "white",
    fontSize: 20,
    fontWeight: "bold"
}

const sectionBlockStyle = {
    textAlign: "left",
    paddingTop: 5,
    color: "white",
    fontSize: 17,
    fontWeight: "normal",
    lineHeight: 1.6
}

const linkStyle = {
    color: "white",
    fontSize: 17,
    fontWeight: "normal",
    textDecoration: "none",
    cursor: "pointer"
}

const inputFieldStyle = {
    fontSize: 17,
    backgroundColor: "#F13349",
    border: "1px solid white",
    borderRadius: 8,
    lineHeight: 2,
    color: "white",
    paddingLeft: 10,
    maxWidth: 216,
    width: "calc(100% - 12px)"
}

const dSession = {
    data: {
        destinations: demoData.destinations
    }
}
const DestinationItem =(props) => <div><i.NavLink style={linkStyle} to={i.Utils.locUrl("destinations/"+props.item.name)}>{props.item.translations[0] ? props.item.translations[0].title : props.item.name}</i.NavLink></div>
//const DestinationItem =(props) => <div><i.NavLink style={linkStyle} to={i.Utils.locUrl("destinations/"+props.item.name)}>{props.item.translations[0].title}</i.NavLink></div>
const ServiceItem =(props) => <div style={props.style}><i.NavLink style={linkStyle} to={i.Utils.locUrl(props.item.path)}>{props.item.name}</i.NavLink></div>

class Footer extends Component {

    componentDidMount() {
        const script = document.createElement("script");

        script.src = "https://russiatourism.ru/operators/widget/js/widget.js";
        script.async = false;

        script.onload = function () {
            console.log('RT loaded');
            const myscr = document.createElement("script");
            document.body.appendChild(myscr);
            const scriptText = document.createTextNode("RT.Widget.build('%D0%A0%D0%A2%D0%9E+021361');");
            myscr.appendChild(scriptText);
        }

        document.body.appendChild(script);
    }

    constructor(props) {
        super(props);
        this.state = {
            allServicesVisible: false,
            allDestinationsVisible: false,
            emailValue: undefined,
            emailMessage: undefined
        };
    }

    onEmailChange = (e) => {
        this.setState( {
            emailValue: e.target.value,
            emailValid: validate.isEmail(e.target.value),
        });
    }

    onSubscribe = () => {

        fetch(cfg.requestSubmitUrl, {
        method: "post",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            email: this.state.emailValue,
            requestType: 'subscribe'
        })
        })
        .then( (response) => { 
            const text = Session.model.common.request.commonSuccessMessage ? Session.model.common.request.commonSuccessMessage : 'Your request cannot be sent at the moment, please try again later.'     
            this.setState( { emailMessage: text });
        })
        .catch( (error) => {
            const text = Session.model.common.request.commonErrorMessage ? Session.model.common.request.commonErrorMessage : 'Your request cannot be sent at the moment, please try again later.';
            this.setState( { emailMessage: text });
        });
    }

    renderServices = () => {
        let items = [];

        let itemsCounter = 0;
        let moreServices = false;

        let allServicesVisible = this.state.allServicesVisible;
        
        navigation.forEach(navItem => {
            if(itemsCounter >= 8 && !allServicesVisible) {
                moreServices = true;
                return;
            }
            let serviceItem = {
                path: navItem.path,
                name: Session.model.navigation[navItem.name]
            }            
            items.push(<ServiceItem item={serviceItem}/>);
            itemsCounter++;

            if (navItem.children) {
                navItem.children.forEach(navItem2 => {
                    let serviceItem2 = {
                        path: navItem2.path,
                        name: Session.model.navigation[navItem.name + 'Children'][navItem2.name]
                    }
                    items.push(<ServiceItem style={{paddingLeft: 28}} item={serviceItem2}/>);
                    itemsCounter++;
                });
            }
        });

        if(moreServices && !allServicesVisible) {
            items.push(<div style={linkStyle} onClick={() => this.setState({allServicesVisible: true})}>{Session.model.common.more}</div>)
        }

        return items;
    }

    render() {

        // let destinations = dSession.data.destinations.slice(0, this.state.allDestinationsVisible ?  dSession.data.destinations.length : 5);
        let destinations = Session.model.destinationPages.slice(0, this.state.allDestinationsVisible ?  Session.model.destinationPages.length : 5);
        let moreDestinations = Session.model.destinationPages.length > destinations.length;      
        const wrongEmail = Session.model.common.request.requiredFieldMessage ? Session.model.common.request.requiredFieldMessage + ' ' + Session.model.common.words.email : 'Invalid email';  

        return (
            <PureGridProvider maxWidth={'auto'}  gutterSize={0}>
                <Container style={{ backgroundColor: '#F13349' }}>
                    <Container fluid={false}>
                        <Row style={{margin: 0,  paddingTop: 10}}>
                            <Col mdOffset={0} md={3} sm={6} xsOffset={4} xs={4} align="left">
                                <h3 style={titleStyle}>{Session.model.common.footer.services}</h3>
                                <div style={sectionBlockStyle}>{
                                    this.renderServices()                                    
                                }
                                </div>
                            </Col>
                            <Col mdOffset={0} md={3} sm={6} xsOffset={4} xs={4} align="left">
                                <h3 style={titleStyle}>{Session.model.common.footer.destinations}</h3>
                                <div style={sectionBlockStyle}>
                                    {destinations.map(dest => <DestinationItem item={dest} /> )}
                                    {moreDestinations ? <div style={linkStyle} onClick={() => this.setState({allDestinationsVisible: true})}>{Session.model.common.more}</div> : null}
                                </div>
                            </Col>
                            <Col mdOffset={0} md={3} sm={6} xsOffset={4} xs={4} align="left">
                                <h3 style={titleStyle}>{Session.model.common.footer.stayintouch}</h3>
                                <div style={sectionBlockStyle}>
                                    <div>
                                        {
                                            !this.state.emailMessage ? ( <span>
                                            <input style={inputFieldStyle} type="text" placeholder="Email" onChange={this.onEmailChange}/>
                                            {(this.state.emailValue!=undefined && !this.state.emailValid) ? <div style={{color: 'yellow', fontWeight: 'bold', fontSize: 12}}>{wrongEmail}</div> : null}</span>
                                            ) : <div style={{color: 'white', fontWeight: 'bold', fontSize: 18}}>{ this.state.emailMessage}</div>
                                        
                                            }

                                    </div>
                                    {!this.state.emailMessage ? <div><a className='active' style={linkStyle} onClick={this.state.emailValid ? this.onSubscribe : undefined}>{Session.model.common.footer.subscribe}</a></div> : null }
                                    <div style={{marginTop: 10}}>{Session.model.common.footer.followus}</div>
                                    <div>
                                        {Session.model.common.contacts.facebook &&<a style={linkStyle} href={Session.model.common.contacts.facebook}><i.Icon icon={i.faIcons.facebookOfficial} size="20" style={{paddingRight: 10}} /></a>}
                                        {Session.model.common.contacts.linkedin && <a style={linkStyle} href={Session.model.common.contacts.linkedin}><i.Icon icon={i.faIcons.linkedin} size="20" style={{paddingRight: 10}}/></a>}
                                        {Session.model.common.contacts.instagram && <a style={linkStyle} href={Session.model.common.contacts.instagram}><i.Icon icon={i.faIcons.instagram} size="20"/></a>}
                                    </div>
                                </div>
                            </Col>
                            <Col mdOffset={0} md={3} sm={6} xsOffset={4} xs={4} align="left">
                                <h3 style={titleStyle}>{Session.model.common.footer.contactus}</h3>
                                <div style={sectionBlockStyle}>
                                    <div style={{textTransform: "capitalize"}}><strong>{Session.model.common.words.address}:</strong></div>
                                    <div>{Session.model.common.contacts.address}</div>
                                    <div style={{textTransform: "capitalize"}}><strong>{Session.model.common.words.phone}:</strong></div>
                                    {Session.model.common.contacts.phones.map(p => <div>{p.phone}</div> )}
                                    <div><strong>Email: </strong><a style={linkStyle} href={"mailto:" + Session.model.common.email} >{Session.model.common.email}</a></div>
                                </div>
                            </Col>
                        </Row>
                        <i.Row>
                            <i.Col mdOffset={3} md={6} xs={12} >
                                <i.Row style={{padding: 15}}>
                                    <i.Col xs={6} align="right" style={{paddingRight: 10}}>
                                        <div><i.NavLink style={linkStyle} to={i.Utils.locUrl("")}>Legal notice</i.NavLink></div>
                                    </i.Col>
                                    <i.Col xs={6} align="left" style={{paddingLeft: 10}}>
                                        <div><i.NavLink style={linkStyle} to={i.Utils.locUrl("")}>Terms of Use</i.NavLink></div>
                                    </i.Col>
                                </i.Row>
                                <i.Row style={{padding: 5}}>
                                    <i.Col lg={4} lgOffset={4} md={8} mdOffset={2} xs={6} xsOffset={3} sm={4} smOffset={4} style={{paddingLeft: 10, paddingRight: 10 }}>
                                    <div><i.NavLink style={linkStyle} to="#"><img src={emvIcon} alt="emv"/> </i.NavLink></div>
                                    </i.Col>
                                </i.Row>
                            </i.Col>
                            <i.Col md={3} xs={12}>
                                 <div id='russiatourism_widget' style={{height: 59}}></div>
                            </i.Col>
                        </i.Row>
                    </Container>
                </Container>
            </PureGridProvider>
        );
    }
}

export default Footer;